export default __webpack_public_path__ + "1e385f1960e93778ee33b8990cdf6106.png";